module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/maria-sarna-78ff54614a8cebbe10cd65b922791697.png";